import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logomenu';
import Icon from '../../components/icon/Icon';
import useDarkMode from '../../hooks/useDarkMode';

const Brand = ({ asideStatus, setAsideStatus }) => {
	const { darkModeStatus } = useDarkMode();
	return (
		<div
			className='brand'
			style={{
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
				justifyContent: asideStatus ? 'space-between' : 'center',
				height: asideStatus ? null : 'fit-content',
			}}>
			{asideStatus && (
				<div className='brand-logo'>
					<h1 className='brand-title '>
						<Link to='/' aria-label='Logo' alt='Facit'>
							<Logo width={140} height={32} />
						</Link>
					</h1>
				</div>
			)}
			<button
				type='button'
				className='btn brand-aside-toggle'
				aria-label={asideStatus ? 'Collapse Aside' : 'Expand Aside'}
				onClick={() => setAsideStatus(!asideStatus)}
				style={
					asideStatus
						? {
								background: 'transparent',
								border: 'none',
								padding: 0,
								marginLeft: '0.5rem',
						  }
						: {
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								width: '100%',
								background: 'transparent',
								border: 'none',
								padding: '0.25rem 0',
						  }
				}>
				<Icon
					icon={asideStatus ? 'FirstPage' : 'LastPage'}
					color={darkModeStatus ? 'light' : 'dark'}
				/>
			</button>
		</div>
	);
};
Brand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
